import React, { ComponentProps } from 'react';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../components/organisms/BlockInteractions';
import { Icons } from '../../components/atoms/SVG';
import { Namespace } from '../../translation/namespace';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { asFetchableBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, DeleteAction, EditView, Views } from '../../types/BlockWithViews';
import { LoginDescriptionDefaultView } from './views/LoginDescriptionDefaultView';
import { LoginDescriptionEditView } from './views/LoginDescriptionEditView';
import { HeadingHierarchy } from '../../_lib/components/Heading/Heading';

type LoginDescriptionProps = Views<
  DefaultView<LoginDescriptionDefaultView> & EditView<LoginDescriptionEditView> & DeleteAction
>;

/**
 * LoginDescription Block in PortalSettings.
 */
export function LoginDescription(props: LoginDescriptionProps) {
  const { t } = useSonTranslation('LoginDescription');
  const { uuid, elementType } = useBlockContext();
  const headline: { text: string; hierarchy: HeadingHierarchy; visible: true } = {
    text: t('headline'),
    hierarchy: 2,
    visible: true,
  };

  const createButtonsObject = () => {
    const EditButton = createButtonObject(
      BlockInteractionsViews.EDIT,
      Icons.EDIT_PENCIL,
      `${Namespace.LoginDescription}:buttons.edit`,
      DISPLAY_TYPE.COLLAPSIBLE,
      <LoginDescriptionEditView {...props.views.edit} />
    );

    const DeleteButton = createButtonObject(
      BlockInteractionsViews.DELETE,
      Icons.ERASER,
      `${Namespace.LoginDescription}:buttons.delete`,
      DISPLAY_TYPE.MODAL,
      null
    );

    return { ...EditButton, ...DeleteButton };
  };

  return (
    <BlockInteractions
      uuid={uuid}
      headline={headline}
      alwaysShowInfo
      views={props.views}
      activeView={props.activeView}
      buttons={createButtonsObject()}
      elementType={elementType}
    >
      <LoginDescriptionDefaultView {...props.views.default} />
    </BlockInteractions>
  );
}

export const LoginDescriptionBlock = asFetchableBlock(LoginDescription, BlockType.logindescription);
export type LoginDescriptionBlock = ComponentProps<typeof LoginDescriptionBlock>;
